import { render, staticRenderFns } from "./ItemContent.vue?vue&type=template&id=5d4de157&"
import script from "./ItemContent.vue?vue&type=script&lang=js&"
export * from "./ItemContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports